import { Directive, HostListener } from '@angular/core';
import { Events } from 'ionic-angular';

@Directive({
  selector: '[open-notifications]'
})
export class OpenNotificationsDirective {

  @HostListener('click', ['$event'])
  handleClick(event: Event) {
    this.events.publish('notifications:open');
  }

  constructor(public events: Events) {}

}



// WEBPACK FOOTER //
// ./src/directives/open-notifications/open-notifications.ts